import AdminUsersTable from './tables/AdminUsersTable';
import { SectionHeader, BfiCustomStore, Accordion } from '../common/SharedComponents';
import store, { searchActions, adminUserActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import AdminRolesModal from './modals/AdminRolesModal';
import AdminUserModal from './modals/AdminUserModal';
import { hasPermission } from '@apply/ui';
import { PermissionType } from '@apply/constants';

function AdminUserSummary() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const undeletedStore = new BfiCustomStore();
    const deletedStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        dispatch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    adminUser: event.target.value,
                },
            })
        );
    };

    const onAddAccount = () => {
        if (!hasPermission(PermissionType.AdminUserCreate)) {
            return;
        }

        dispatch(
            adminUserActions.setAdminUserModal({
                adminUserModal: { isOpen: true, id: 0 },
            })
        );
    };

    const getAddText = () => {
        if (hasPermission(PermissionType.AdminUserCreate)) {
            return 'Add Admin Account';
        }
        return null;
    };

    return (
        <>
            <SectionHeader
                title='Manage Admin Users'
                buttonText={getAddText()}
                buttonCallback={() => onAddAccount()}
            />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search to Filter Users'
                        value={searchState.searchText?.adminUser}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <Accordion
                            title='Active Accounts'
                            isExpanded={true}
                            id={`admin_undeleted`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <AdminUsersTable
                                        gridStore={undeletedStore}
                                        isDeleted={false}
                                    />
                                </div>
                            </div>
                        </Accordion>
                        <Accordion
                            title='Deleted Accounts'
                            isExpanded={false}
                            id={`admin_deleted`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <AdminUsersTable
                                        gridStore={deletedStore}
                                        isDeleted={true}
                                    />
                                </div>
                            </div>
                        </Accordion>
                    </div>
                </div>
            </div>
            <AdminRolesModal />
            <AdminUserModal />
        </>
    );
}

export default AdminUserSummary;
